// @import dependencies
import { store } from 'app_storage/redux-storage'
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {ModalUserFormModuleLayout} from 'app_components/modules/campus/user/modalUserForm'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import UserService from 'app_services/user/userService'
import { UserFormSections } from 'app_types/userTypes'
// @end

// @import types
// @end

// @ADD Component types
interface IModalUserFormModuleProps {
  id: string
  open: boolean
  handleClose: (data:any)=>void
  reviewUserInformation?: boolean
  origin: UserFormSections
}
interface IModalUserFormModuleState {
  user: any
  status: 'loading' | 'error' | null
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class ModalUserFormModule extends Component<IModalUserFormModuleProps, IModalUserFormModuleState> {

  private userId: string | null = null
  private storeObject: any
  private userService: UserService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IModalUserFormModuleProps) {
    super(props)
    this.storeObject = store

    this.state = {
      user: null,
      status: 'loading',
    }

    this.userId = this.storeObject.getState().auth?.user?.data?.id
    this.userService = new UserService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    if (this.userId) {
      const userResponse = await this.userService.getOne(this.userId)
      if (userResponse) {
        this.setState({user: userResponse, status: null})
      }
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  render() {
    return(
      <ModalUserFormModuleLayout
        id={this.props.id}
        open={this.props.open}
        handleClose={this.props.handleClose}
        user={this.state.user}
        status={this.state.status}
        userId={this.userId || ''}
        origin={this.props.origin}
      />
    )
  }
}

export default connect(mapStatesToProps)(ModalUserFormModule)
